module.exports = __webpack_public_path__ + "img/logo-newebpay.129e2574.png";